import { Injectable, Injector } from '@angular/core';
import { ReportPayrollRunSummary } from '../entities/report-payroll-run-summary';
import { BaseReportService } from '../../shared/_utils/services/base-report-service';
import { LazyLoadEvent } from 'primeng/api';
import { HttpParams } from '@angular/common/http';
import { Vars } from '../model/vars';
import { Observable } from 'rxjs/Observable';
import { tap } from 'rxjs/operators';
import { ReportWayToPay } from './../model/report-way-to-pay';

@Injectable()
export class ReportWayToPayService extends BaseReportService<ReportWayToPay> {

  public uri = '/api/reportWayToPay/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance ReportWayToPayService');
  }

  buildSentence(entity?: ReportPayrollRunSummary, event?: LazyLoadEvent): HttpParams {
    return null;
  }

  searchToViewTable(   fiscalYear: any,
    executingUnit: any,
    month: any,
    payrollType: any,
    employeeType: any,
    bank?: any,
    employee?: any,
    object?: Vars
    ): Observable<any> {
      const params = new HttpParams()
        .set('fiscalYearId', fiscalYear)
        .set('euId', executingUnit)
        .set('monthId', month)
        .set('payrollTypeId', payrollType)
        .set('employeeTypeId', employeeType)
        .set('bankId', bank)
        .set('employeeId', employee)
        this.spinnerService.showAll();
        const url = `${this.rutaServidor}${this.uri}search`;
        return this.httpClient.post<any>(url, object, {params}, )
        .pipe(
          tap(response => {
            this.spinnerService.hideAll();
            return response;
          })
       );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/report-way-to-pay.service.ts